import { render, staticRenderFns } from "./FormFconttitreedit.vue?vue&type=template&id=2c98a25b&"
import script from "./FormFconttitreedit.vue?vue&type=script&lang=js&"
export * from "./FormFconttitreedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports